export default __webpack_public_path__ + "static/media/calendar_time.4533eee1.svg";